import React, { FC, useState, ReactElement, Dispatch, SetStateAction } from 'react'
import { Formik } from 'formik'
import * as yup from 'yup'
import { Form, Alert } from 'react-bootstrap'
import { useHistory } from 'react-router-dom'
import Auth from '@aws-amplify/auth'

import LoadingButton from '../../LoadingButton'

interface Props {
  setSentCode: Dispatch<SetStateAction<boolean>>
  setLoginStage: (loginStage: 'reset' | 'signup') => void
}

const schema = yup.object({
  email: yup
    .string()
    .email('Email must be a valid email')
    .required('Email is a required field'),
})

const ForgotPasswordForm: FC<Props> = ({ setSentCode, setLoginStage }) => {
  const [isLoading, setIsLoading] = useState(false)
  const history = useHistory()
  const [errorMessage, setErrorMessage] = useState('')

  const sendForgotPasswordEmail = async (values: { email: string }): Promise<void> => {
    setIsLoading(true)

    try {
      await Auth.forgotPassword(values.email.toLowerCase())

      setLoginStage('reset')
      setErrorMessage('')
      setSentCode(true)
      history.push(`/reset-password/${values.email}`)
    } catch (e) {
      setErrorMessage(e.message)
      setIsLoading(false)
    }
  }

  return (
    <>
      {errorMessage && (
        <Alert variant="danger">
          <Alert.Heading>Error</Alert.Heading>
          <hr />
          <span>{errorMessage}</span>
        </Alert>
      )}
      <Formik
        validationSchema={schema}
        onSubmit={sendForgotPasswordEmail}
        initialValues={{
          email: '',
        }}
      >
        {({ handleSubmit, values, handleChange, touched, errors, submitCount }): ReactElement => (
          <Form noValidate onSubmit={handleSubmit}>
            <Form.Group controlId="email">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                required
                value={values.email}
                onChange={handleChange}
                isValid={touched.email && !errors.email}
                isInvalid={submitCount > 0 && !!errors.email}
                placeholder="callsign@domainname.com"
              />
              <Form.Control.Feedback type="invalid">
                <Alert variant="danger">{errors.email}</Alert>
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group controlId="actions" className="actions">
              <LoadingButton
                className="forgot-password-button"
                variant="primary"
                type="submit"
                block
                isLoading={isLoading}
              >
                SUBMIT
              </LoadingButton>
            </Form.Group>
          </Form>
        )}
      </Formik>
    </>
  )
}

export default ForgotPasswordForm
